<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>Love At Mistletoe Inn: A December Wedding Story: A Year of Weddings Novella</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ct"><i>Contents</i></p>
<p class="cct"><a href="#/chapter1#aa_1" id="bb_1">Chapter One</a></p>
<p class="cct"><span href="#/chapter2#aa_2" id="bb_2" title="Link target outside of Sample">Chapter Two</span></p>
<p class="cct"><span href="#/chapter3#aa_3" id="bb_3" title="Link target outside of Sample">Chapter Three</span></p>
<p class="cct"><span href="#/chapter4#aa_4" id="bb_4" title="Link target outside of Sample">Chapter Four</span></p>
<p class="cct"><span href="#/chapter5#aa_5" id="bb_5" title="Link target outside of Sample">Chapter Five</span></p>
<p class="cct"><span href="#/chapter6#aa_6" id="bb_6" title="Link target outside of Sample">Chapter Six</span></p>
<p class="cct"><span href="#/chapter7#aa_7" id="bb_7" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="cct"><span href="#/chapter8#aa_8" id="bb_8" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="cct"><span href="#/chapter9#aa_9" id="bb_9" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="cct"><span href="#/chapter10#aa_10" id="bb_10" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="cct"><span href="#/chapter11#aa_11" id="bb_11" title="Link target outside of Sample">Epilogue</span></p>
<p class="cct"><span href="#/chapter12#aa_12" id="bb_12" title="Link target outside of Sample">Discussion Questions</span></p>
<p class="cct"><span href="#/chapter13#aa_13" id="bb_13" title="Link target outside of Sample">About the Author</span></p>
<p class="cct"><span href="#/chapter14#aa_14" id="bb_14" title="Link target outside of Sample">An Excerpt from a Brush With Love</span> By Rachel Hauck</p>
<p class="cct1"><span href="#/chapter14#aa_14_1" id="bb_14_1" title="Link target outside of Sample">Chapter One</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?9c67f404